import { origin, protocol } from '../../../store/addons'
import axios from 'axios'
import qs from 'qs'
import Notifications from 'react-notification-system-redux'
import {
  loginSuccess,
  loginError,
  logoutSuccess,
  logoutError
} from '../../../store/toasts'

// Store Initialization
// ------------------------------------
// ------------------------------------
// Constants
// ------------------------------------
export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'
export const ERROR = 'ERROR'

// ------------------------------------
// Actions
// ------------------------------------

const logInAction = (data = undefined) => {
  return {
    type: LOG_IN,
    data: data
  }
}

const logOutAction = () => {
  return {
    type: LOG_OUT
  }
}

const validErrorAction = () => {
  return {
    type: ERROR
  }
}
export const logIn = (email, password) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      axios.post(`${protocol}//${origin}/api/users/login`, qs.stringify({ email: email, password: password }),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
        .then((json) => {
          localStorage.setItem('bravetoken', json.data.token)
          localStorage.setItem('tokenDate', (new Date().getTime() + 3600000))
          localStorage.setItem('braveuser', JSON.stringify(json.data))
          dispatch(logInAction(json.data))
          dispatch(Notifications.success(loginSuccess))
          resolve()
        })
        .catch((error) => {
          dispatch(validErrorAction())
          console.log(error)
          dispatch(Notifications.error(loginError))
          resolve()
        })
    })
  }
}

export const logOut = () => {
  return (dispatch) => {
    localStorage.removeItem('bravetoken')
    localStorage.removeItem('tokenDate')
    localStorage.removeItem('braveuser')
    dispatch(Notifications.success(logoutSuccess))
    return window.store.dispatch(logOutAction())
  }
}

export const checkLogin = () => {
  return dispatch => {
    let bravetoken = localStorage.getItem('bravetoken')
    let tokenDate = parseInt(localStorage.getItem('tokenDate'))
    let braveuser = localStorage.getItem('braveuser')
    if (bravetoken && braveuser) {
      if ((new Date(tokenDate)).getTime() + 3600000 > (new Date()).getTime()) {
        localStorage.setItem('tokenDate', (new Date()).getTime() + 3600000)
      } else {
        dispatch(logOutAction())
        return
      }

      return new Promise((resolve) => {
        axios.get(`${protocol}//${origin}/api/users/check-user`, { headers: { 'Authorization': 'Bearer '+ bravetoken } })
          .then((json) => {
            localStorage.setItem('tokenDate', (new Date()).getTime() + 3600000)
            localStorage.setItem('braveuser', JSON.stringify(json.data))
            dispatch(logInAction(json.data))
            resolve()
          })
          .catch((error) => {
            localStorage.removeItem('bravetoken')
            localStorage.removeItem('tokenDate')
            localStorage.removeItem('braveuser')
            dispatch(logOutAction())
            console.log(error)
            resolve()
          })
      })
    } else {
      dispatch(logOutAction())
    }
  }
}

export const actions = {
  logIn,
  logOut,
  checkLogin
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [LOG_IN]: (state, action) => { return { ...state, isLoggedIn: true, user: action.data } },
  [LOG_OUT]: (state, action) => { return { ...state, isLoggedIn: false, user: '' } },
  [ERROR]: (state, action) => { return { ...state, validError: true } }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isLoggedIn: true,
  validError: false,
  user: ''
}

export default function loginReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/components/AdminPanel/module/login.js